"use client";
import React, { useState } from "react";
import CallBackForm from "./CallBackForm";
import Modal from "../../theme/components/Modal";

const CallbackButton = ({ title }) => {
  const [contactFormVisible, setContactFormVisible] = useState(false);
  const toggleContactForm = () => {
    setContactFormVisible(!contactFormVisible);
  };

  return (
    <>
      <Modal
        open={contactFormVisible}
        onClose={() => setContactFormVisible(false)}
        title=""
      >
        <CallBackForm
          className="mx-3"
          visible
          onHide={() => setContactFormVisible(false)}
        />
      </Modal>
      <button type="button" onClick={toggleContactForm} className="d-block">
        {title}
      </button>
    </>
  );
};
export default CallbackButton;
